import React, { useState, useContext } from 'react';
import { LanguageContext } from '../components/LanguageContext';

const StudentsZone = () => {
  const [activeTab, setActiveTab] = useState('jobs');
  const { language } = useContext(LanguageContext);

  const jobOpenings = [];
  const learningMaterials = [];

  const EmptyStateCard = ({ type }) => (
    <div className="p-6 bg-white rounded-lg shadow-md text-center">
      <h3 className="text-xl font-semibold text-gray-700 mb-2">
        {language === 'en' 
          ? `${type === 'jobs' ? 'Job Postings' : 'Learning Materials'} Coming Soon`
          : `${type === 'jobs' ? 'نوکریوں کے اشتہارات' : 'تعلیمی مواد'} جلد آ رہا ہے`}
      </h3>
      <p className="text-gray-600">
        {language === 'en' 
          ? 'Please check back later for updates'
          : 'تازہ ترین معلومات کے لیے بعد میں دوبارہ چیک کریں'}
      </p>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative">
        <div className="h-[300px] relative">
          <img 
            src="https://th-i.thgim.com/public/migration_catalog/article10456065.ece/alternates/FREE_1200/amaravathi"
            alt={language === 'en' ? "Students Corner Header" : "طلباء کا کارنر ہیڈر"} 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-blue-900/40">
            <div className="container mx-auto px-8 h-full flex items-center">
              <div className="max-w-2xl text-white">
                <h1 className="text-3xl md:text-5xl font-bold mb-4">
                  {language === 'en' ? "Students Corner" : "طلباء کا کارنر"}
                </h1>
                <p className="text-lg md:text-xl">
                  {language === 'en' ? "Your gateway to opportunities and resources" : "مواقع اور وسائل تک آپ کا راستہ"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-8 py-6 md:py-12">
        <div className="flex flex-wrap gap-2 sm:gap-4 justify-center mb-6">
          {['jobs', 'learning'].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 sm:px-6 lg:px-8 py-2 rounded-lg ${
                activeTab === tab ? 'bg-yellow-300 text-black' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {language === 'en'
                ? tab.charAt(0).toUpperCase() + tab.slice(1)
                : tab === 'jobs' ? 'نوکریاں' : 'تعلیمی مواد'}
            </button>
          ))}
        </div>

        {activeTab === 'jobs' && (
          <div className="space-y-6">
            {jobOpenings.length === 0 ? (
              <EmptyStateCard type="jobs" />
            ) : (
              learningMaterials.map((material) => (
                <div key={material.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden">
                  <div className="h-48 relative">
                    <img 
                      src={material.coverImage}
                      alt={material.title_EN}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="text-xl font-semibold">
                        {language === 'en' ? material.title_EN : material.title_UR}
                      </h3>
                      <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-sm">
                        {language === 'en' ? material.level_EN : material.level_UR}
                      </span>
                    </div>
                    <p className="text-gray-600 text-sm mb-2">
                      {language === 'en' ? `By ${material.author_EN}` : `مصنف: ${material.author_UR}`}
                    </p>
                    <p className="text-gray-700 mb-4">
                      {language === 'en' ? material.description_EN : material.description_UR}
                    </p>
                    <button className="w-full bg-blue-800 text-white py-2 rounded-lg hover:bg-blue-900 transition-colors flex items-center justify-center gap-2">
                      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                      </svg>
                      {language === 'en' ? "Download" : "ڈاؤن لوڈ کریں"} {language === 'en' ? material.format_EN : material.format_UR}
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {activeTab === 'learning' && (
            learningMaterials.length === 0 ? (
              <EmptyStateCard type="learning" />
            ) : (
              learningMaterials.map((material) => (
                <div key={material.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden">
                  <div className="h-48 relative">
                    <img 
                      src={material.coverImage}
                      alt={material.title_EN}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="text-xl font-semibold">
                        {language === 'en' ? material.title_EN : material.title_UR}
                      </h3>
                      <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-sm">
                        {language === 'en' ? material.level_EN : material.level_UR}
                      </span>
                    </div>
                    <p className="text-gray-600 text-sm mb-2">
                      {language === 'en' ? `By ${material.author_EN}` : `مصنف: ${material.author_UR}`}
                    </p>
                    <p className="text-gray-700 mb-4">
                      {language === 'en' ? material.description_EN : material.description_UR}
                    </p>
                    <button className="w-full bg-blue-800 text-white py-2 rounded-lg hover:bg-blue-900 transition-colors flex items-center justify-center gap-2">
                      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                      </svg>
                      {language === 'en' ? "Download" : "ڈاؤن لوڈ کریں"} {language === 'en' ? material.format_EN : material.format_UR}
                    </button>
                  </div>
                </div>
              ))
            )
          
        )}
      </div>
    </div>
  );
};

export default StudentsZone;